import Enumerable from "linq";
import { KeyValuePair } from "../domain/system/KeyValuePair";

export class CacheManager<TKey, TValue> {
  constructor(private readonly _count: number, private readonly _reader: (key: TKey) => Promise<TValue>, areKeysEqual?: (a: TKey, b: TKey) => boolean) {
    this._areKeysEqual = areKeysEqual
      ? areKeysEqual
      : (a: TKey, b: TKey) => a === b;
  }

  async get(key: TKey): Promise<TValue> {
    const cache = Enumerable.from(this._cache).firstOrDefault(c => this._areKeysEqual(c.key, key));
    if (!cache) {
      try {
        const read = await this._reader(key);
        if (read) {
          this._cache.push(this.createPair(key, read));
          this._cache = Enumerable.from(this._cache)
            .skip(this._cache.length - this._count)
            .toArray();
        }
        return read;
      } catch (e) {
        // そのままthrowする
        throw e;
      }
    } else {
      const index = this._cache.indexOf(cache);
      this._cache.splice(index, 1);
      this._cache.push(cache);
      return cache.value;
    }
  }

  private createPair(key: TKey, value: TValue): KeyValuePair<TKey, TValue> {
    const result = new KeyValuePair<TKey, TValue>();
    result.key = key;
    result.value = value;
    return result;
  }

  private readonly _areKeysEqual: (a: TKey, b: TKey) => boolean;
  private _cache = [] as KeyValuePair<TKey, TValue>[];
}
